module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_biblio"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_vm._v("Bibliography")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This list includes works referred to in the footnotes by the author’s surname, or surname and date, and recommended further reading.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Ackroyd, P. R., "), _c('i', [_vm._v("The First Book of Samuel ")]), _vm._v("(Cambridge: Cambridge University Press, 1971).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("____, "), _c('i', [_vm._v("The Second Book of Samuel ")]), _vm._v("(Cambridge: Cambridge University Press, 1977).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Alter, R., "), _c('i', [_vm._v("The David Story ")]), _vm._v("(New York: Norton, 1999).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Anderson, A. A., "), _c('i', [_vm._v("2 Samuel")]), _vm._v(", WBC 11 (Waco: Word, 1989).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Baldwin, J., "), _c('i', [_vm._v("1 and 2 Samuel: An Introduction and Commentary")]), _vm._v(", TOTC (Leicester: Inter-Varsity, 1988).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Brueggemann, W., "), _c('i', [_vm._v("First and Second Samuel: Interpretation")]), _vm._v(", A Bible Commentary for Teaching and Preaching (Lousiville: John Knox, 1990).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Caird, G. B., ‘The First and Second Books of Samuel’, in G. A. Buttrick et al. (eds.), IntB, Vol. 2 (Nashville: Abingdon, 1953).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Clines, D. J. A., and T. Eskeanzi (eds.), "), _c('i', [_vm._v("Telling Queen Michal’s Story – An Experiment in Comparative Interpretation")]), _vm._v(", JSOTS 119 (Sheffield: Sheffield Academic Press, 1991).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Craigie, P. C., "), _c('i', [_vm._v("The Book of Deuteronomy")]), _vm._v(", NICOT (Grand Rapids: Eerdmans, 1976).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Davis, D. R., "), _c('i', [_vm._v("1 Samuel: Looking on the Heart ")]), _vm._v("(Fearn: Christian Focus Publications, 2000).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Eaton, M. A., "), _c('i', [_vm._v("1 Samuel ")]), _vm._v("(Tonbridge: Sovereign World, 1996).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("____, "), _c('i', [_vm._v("2 Samuel ")]), _vm._v("(Tonbridge: Sovereign World, 1996).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Evans, M. J., "), _c('i', [_vm._v("1 and 2 Samuel")]), _vm._v(", NIBC (Peabody: Hendrickson, 2000).")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_vm._v("Gordon, R. P., "), _c('i', [_vm._v("1 and 2 Samuel ")]), _vm._v("(Sheffield: JSOT Press, 1984).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("____, "), _c('i', [_vm._v("1 and 2 Samuel: A Commentary ")]), _vm._v("(Exeter: Paternoster, 1986).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Hertzberg, H. W., "), _c('i', [_vm._v("I & II Samuel")]), _vm._v(", OTL (ET) (London: SCM, 1964).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Hester, D. C., "), _c('i', [_vm._v("First and Second Samuel ")]), _vm._v("(Louisville: Geneva Press, 2000).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Jensen, I. L., "), _c('i', [_vm._v("First and Second Samuel ")]), _vm._v("(Chicago: Moody Press, 1995).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Jones, G. H., "), _c('i', [_vm._v("The Nathan Narratives")]), _vm._v(", JSOTS 80 (Sheffield: Sheffield Academic Press, 1990).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Kirkpatrick, A. F., "), _c('i', [_vm._v("The First Book of Samuel ")]), _vm._v("(Cambridge: Cambridge University Press, 1888).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("____, "), _c('i', [_vm._v("The Second Book of Samuel ")]), _vm._v("(Cambridge: Cambridge University Press, 1889).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Klein, R. W., "), _c('i', [_vm._v("1 Samuel")]), _vm._v(", WBC 19 (Waco: Word, 1983).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Knight, D. A., ‘Deuteronomy and the Deuteronomists’, in J. A. Mays et al. (eds.), "), _c('i', [_vm._v("Old Testament Introduction, Past, Present and Future ")]), _vm._v("(Edinburgh: T. & T. Clark, 1995).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Laney, J. C., "), _c('i', [_vm._v("First and Second Samuel ")]), _vm._v("(Chicago: Moody Press, 1995).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Mauchline, J., "), _c('i', [_vm._v("1 and 2 Samuel")]), _vm._v(", NCB (London: Oliphants, 1971).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("McCarter, P. K., "), _c('i', [_vm._v("I Samuel")]), _vm._v(", AB (New York: Doubleday, 1980).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("____, "), _c('i', [_vm._v("II Samuel")]), _vm._v(", AB (New York: Doubleday, 1984).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Miller, P. D., "), _c('i', [_vm._v("Deuteronomy ")]), _vm._v("(Louisville: John Knox Press, 1990).")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Provan, I. W., "), _c('i', [_vm._v("1 and 2 Kings")]), _vm._v(", NIBC (Peabody: Hendrickson, 1995).")])])])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 78
// module chunks = 0